<template>
    <div
        class="rate-offers-container"
        :class="{ 'no-offers': showNoOffers }">
        <transition
            v-if="showLoading"
            name="fade">
            <div class="loader">
                <img
                    alt="lt-loader"
                    width="61"
                    height="60"
                    src="data:image/png;base64,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"
                />
                <span>Searching for offers...</span>
            </div>
        </transition>
        <div v-if="showNoOffers">
            <div class="no-offers-found">
                <p class="text-left">
                    Thank you for using LendingTree’s marketplace for your home <span v-show="loanType == 'Purchase'">loans</span><span v-show="loanType == 'Refinance'">refinance</span>. Unfortunately, based on the information you’ve provided, we’re unable to display rates for you at this time. Try adjusting your criteria, such as your requested loan amount, to see what lenders are waiting to offer you competitive rates.
                </p>
                <div class="still-no-offers">
                    <h4>Still no rate offers?</h4>
                    <p>Take a few minutes and fill out more information to get your best rate.</p>
                    <span v-if="destinationLinkOrId != ''">
                        <a
                            :href="getDestinationUrl(destinationLinkOrId)"
                            class="destination-btn">Get My Rate</a>
                    </span>
                    <span v-else>
                        <a
                            v-show="loanType == 'Purchase'"
                            :href="getDestinationUrl('wp-mortgage')"
                            class="destination-btn">Get My Rate</a>
                        <a
                            v-show="loanType == 'Refinance'"
                            :href="getDestinationUrl('wp-refinance')"
                            class="destination-btn">Get My Rate</a>
                    </span>
                </div>
            </div>
        </div>
        <div
            v-if="HasData"
            class="rate-offers">
            <div
                v-for="(loanProgram, index) in loanPrograms"
                :key="index"
                class="tab">
                <a
                    :id="'program-tab-' + index"
                    class="program-tab"
                    :class="index === ActiveTabIndex ? 'active' : ''"
                    href="javascript:void(0)"
                    @click="filterOfferResult(loanProgram)">
                    {{ TabNames[loanProgram] }}
                </a>
                <div
                    class="bottom-border"
                    :class="index === ActiveTabIndex ? 'active' : ''">
&nbsp;
                </div>
            </div>
        </div>
        <div
            v-if="HasData"
            class="tab-content">
            <div
                v-if="FilteredOfferResult && FilteredOfferResult.length"
                class="offer-block">
                <table class="offer-result">
                    <thead class="visually-hidden">
                    </thead>
                    <tbody>
                        <loan-offers
                            v-for="(offer, index) in FilteredOfferResult"
                            :key="index"
                            :offer="offer"
                            :loan-amount="loanAmount"
                            :zip-code="zipCode"
                            :home-value="homeValue"
                            :destination-link-or-id="destinationLinkOrId"
                            :destination-button-text="destinationButtonText"
                            :cta-params="ctaParams"
                        />
                        <br />
                    </tbody>
                </table>
            </div>
            <div
                v-else
                class="text-center mt-sm">
                No lenders available
            </div>
        </div>
        <div
            v-if="HasData"
            class="disclaimer">
            The Rates, APRs, Fees, and Monthly Amounts above are estimates only and are not guaranteed. The information provided is for illustrative purposes only and is merely a conditional quote subject to change, may not be available in all states, and are based on loan amount requested and creditworthiness as determined by the lender selected. Your financial information will be required to be verified and subject to formal credit approval by the lender selected. LendingTree receives payment from the lenders Mortgage offers that appear on this site are from companies from which LendingTree receives compensation. This compensation may impact how and where products appear on this site (including for example, the order in which they appear or whether a lender is "featured" on the site). LendingTree does not include all Mortgage companies or all types of offers available in the marketplace.
            <br />
            Mortgage Lenders determine the underwriting criteria necessary for approval; you should review each Lender's terms and conditions to determine which loan works for you and your personal financial situation. All reasonable efforts are made to provide and maintain accurate information. All rates, fees, and terms are presented without guarantee and are subject to change pursuant to each Lender's discretion. There is no guarantee you will be approved for credit or that upon approval you will qualify for the advertised rates, fees, or terms shown. <advertising-disclosures
                :disclosure-id="DisclosureId"
                :disclosure-text="DisclosureText"
                :disclosure-tokens="DisclosureTokens"
                class="lt-howitworks disclosure-sec"
            />.
        </div>
    </div>
</template>
<script>
    import LoanOffers from './loan-offers.vue';
    import AdvertisingDisclosures from '~/components/advertising-disclosures.vue';
    import wwwUrlEnv from '~/helpers/www-url-env';
    import RateTableInfo from '~/mixin/rate-table-offer-tracking';

    export default {
        components: {
            LoanOffers,
            AdvertisingDisclosures,
        },
        mixins: [RateTableInfo],
        props: {
            loanType: {
                default: '',
            },
            offerResult: {
                type: Array,
                default: () => [],
            },
            loanPrograms: {
                default: [],
            },
            defaultLoanProgram: {
                default: '',
            },
            loanAmount: {
                default: 0,
            },
            zipCode: {
                default: '',
            },
            homeValue: {
                default: 0,
            },
            showLoading: {
                default: false,
            },
            showNoOffers: {
                default: false,
            },
            disclosureId: {
                default: 'Disclosures01',
            },
            disclosureText: {
                default: 'Learn more about how our mortgage rate table works',
            },
            disclosureTokens: {
                default: '000128',
            },
            destinationLinkOrId: {
                default: '',
            },
            destinationButtonText: {
                default: 'Get Free Offers',
            },
            fieldEdited: {
                default: 'no',
            },
            ctaParams: {
                default: '',
            },
        },
        data() {
            return {
                FilteredOfferResult: this.offerResult,
                HasData: false,
                DisclosureText: this.disclosureText,
                DisclosureId: this.disclosureId,
                DisclosureTokens: this.disclosureTokens,
                ActiveTabIndex: 0,
                TabNames: {
                    FIXED_RATE: 'Fixed Rate',
                    VARIABLE_RATE: 'Variable Rate',
                },
            };
        },
        watch: {
            offerResult() {
                this.HasData = this.offerResult && this.offerResult.length > 0;
                if (this.loanPrograms && this.loanPrograms.length > 0) {
                    const defaultLoanProgram = String(this.defaultLoanProgram || '').trim().toLowerCase();
                    let defaultTab = this.loanPrograms[0];

                    if (defaultLoanProgram === 'fixed') {
                        defaultTab = 'FIXED_RATE';
                    } else if (defaultLoanProgram === 'arm') {
                        defaultTab = 'VARIABLE_RATE';
                    }

                    this.filterOfferResult(this.loanPrograms.includes(defaultTab) ? defaultTab : this.loanPrograms[0]);
                }
            },
        },
        methods: {
            activateTab(loanProgram) {
                this.ActiveTabIndex = this.loanPrograms.indexOf(loanProgram);
            },
            filterOfferResult(loanProgram) {
                this.activateTab(loanProgram);
                const offerResultArray = this.offerResult;
                const trackResult = {};
                let index = 1;
                if (offerResultArray) {
                    const result = [];

                    offerResultArray.forEach((offer) => {
                        const normalizedLoanProgram = String(offer.loanProgram || '').toUpperCase();
                        const isFixedRateTabMatch = loanProgram === 'FIXED_RATE' && normalizedLoanProgram.includes('FIXED');
                        const isVariableRateTabMatch = loanProgram === 'VARIABLE_RATE' && normalizedLoanProgram.includes('ARM');

                        if (isFixedRateTabMatch || isVariableRateTabMatch) {
                            offer.position = index;
                            offer.fieldEdited = this.fieldEdited;
                            result.push(offer);
                            index++;
                        }
                    });
                    this.FilteredOfferResult = null;
                    this.$nextTick(() => {
                        this.activateTab(loanProgram);
                        this.FilteredOfferResult = result;
                        trackResult.TrackOfferResult = result;
                        trackResult.fieldEdited = this.fieldEdited;
                        trackResult.loanType = this.loanType;
                        this.rateTableViewedInfo(trackResult);
                    });
                }
            },
            getDestinationUrl(splitter) {
                let url = `${wwwUrlEnv.getWWWURL()}/redirect/offers?id=${splitter}&icid=ratetable`;
                if (this.destinationLinkOrId !== '' && !/^[A-z0-9-]+$/i.test(this.destinationLinkOrId)) {
                    url = `${this.destinationLinkOrId}`;
                }
                return url;
            },
        },
    };
</script>
